module.exports = __webpack_public_path__ + "static/media/gloria48.2e19f052.png";